import { render } from "./black-divider.vue?vue&type=template&id=f60d9fae&scoped=true"
import script from "./black-divider.vue?vue&type=script&lang=js"
export * from "./black-divider.vue?vue&type=script&lang=js"

import "./black-divider.vue?vue&type=style&index=0&id=f60d9fae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f60d9fae"]])

export default __exports__